/**
 * Truncate an ISO timestamp to minute precision by slicing the string.
 * Does not parse timezones — `Z` vs `+00:00` of the same instant can differ.
 */
export function roundToMinute(date: string) {
  return date.slice(0, 16);
}

/**
 * True when both timestamps share the same minute, or either is missing.
 * Missing timestamps are treated as the same so a "Recorded:" line is not shown.
 */
export function isSameDate(
  a: string | null | undefined,
  b: string | null | undefined
) {
  if (!(a && b)) return true;
  return roundToMinute(a) === roundToMinute(b);
}
